/* Keep the existing Shiprocket cart's display synchronized with its rendered line quantities. */
(() => {
  let attached = false;
  const attach = () => {
    const root = document.getElementById('shiprocket-smart-cart-root')?.shadowRoot;
    const items = root?.getElementById('mini-cart-items');
    if (!items || attached) return attached;
    attached = true;
    const sync = () => {
      const count = Array.from(items.querySelectorAll('.mini-cart-item-qty')).reduce((sum, input) => sum + (Number(input.value) || 0), 0);
      const title = root.querySelector('.mini-cart-title');
      const label = root.getElementById('sr-cart-header-quantity');
      if (title && title.textContent !== 'Shopping Cart') title.textContent = 'Shopping Cart';
      if (label && label.textContent !== `(${count})`) label.textContent = `(${count})`;
      const icon = document.getElementById('cart-icon-bubble');
      if (!icon) return;
      let bubble = icon.querySelector('.cart-count-bubble');
      if (!count) { bubble?.remove(); return; }
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        const visible = document.createElement('span'); visible.setAttribute('aria-hidden', 'true');
        const accessible = document.createElement('span'); accessible.className = 'visually-hidden';
        bubble.append(visible, accessible); icon.append(bubble);
      }
      bubble.querySelector('[aria-hidden]')?.replaceChildren(String(count));
      const accessible = bubble.querySelector('.visually-hidden');
      if (accessible) accessible.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
    };
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; sync(); });
    };
    const header = root.querySelector('.mini-cart-header');
    if (header) new MutationObserver(schedule).observe(header, {childList: true, subtree: true});
    new MutationObserver(schedule).observe(items, {childList: true, subtree: true, attributes: true, attributeFilter: ['value']});
    root.addEventListener('change', schedule);
    sync();
    return true;
  };
  if (attach()) return;
  const watcher = new MutationObserver(() => { if (attach()) watcher.disconnect(); });
  watcher.observe(document.body, {childList: true, subtree: true});
  // The app can mount its shadow tree without a document mutation; stop probing after 15 seconds.
  let attempts = 0;
  const timer = setInterval(() => { if (attach() || ++attempts >= 30) { clearInterval(timer); watcher.disconnect(); } }, 500);
})();
